var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUser = function SvgUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    fill: "none",
    viewBox: "0 0 17 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M13.428 14v-1.333c0-.708-.283-1.386-.787-1.886A2.7 2.7 0 0 0 10.742 10h-5.37c-.713 0-1.396.281-1.9.781a2.66 2.66 0 0 0-.786 1.886V14M8.057 7.333a2.676 2.676 0 0 0 2.685-2.666A2.676 2.676 0 0 0 8.057 2 2.676 2.676 0 0 0 5.37 4.667a2.676 2.676 0 0 0 2.686 2.666"
  })));
};
export default SvgUser;